<template>
  <validation-observer ref="AddFaultSupport">
    <b-form class="formBox" style="text-align:left;">
      <div v-if="part == 'info'">
      
      <validation-provider
        name="Seri Numarası"
        :rules="{ required: true }"
        v-slot="validationContext"
      >
        <b-form-group class="inputGrp" label="Seri Numarası" label-for="serialn">
          <b-form-input
            id="serialn"
            v-model="serialNumber"
            :state="getValidationState(validationContext)"
            aria-describedby="live-feedback"
          />
          <b-form-invalid-feedback code="live-feedback" style="display: block">
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <validation-provider
        name="Yan Ürünler"
        :rules="{ required: false }"
        v-slot="validationContext"
      >
        <b-form-group class="inputGrp" label="Yan Ürünler" label-for="pieces">
          <div class="elements">
            <Multiselect
              id="pieces"
              v-model="selectedPieces"
              :show-labels="false"
              :options="pieces"
              :state="getValidationState(validationContext)"
              aria-describedby="live-feedback"
              label="name"
              track-by="id"
              :multiple="true"
              :taggable="true"
              @tag="addTag"
            >
            </Multiselect>
          </div>
          <b-form-invalid-feedback
            stock="live-feedback"
            style="display: block"
            >{{ validationContext.errors[0] }}</b-form-invalid-feedback
          >
        </b-form-group>
      </validation-provider>

      <validation-provider
        name="Problem"
        :rules="{ required: true }"
        v-slot="validationContext"
      >
        <b-form-group class="inputGrp" label="Problem" label-for="problem">
          <b-form-textarea
            rows="5"
            id="problem"
            v-model="problem"
            :state="getValidationState(validationContext)"
            aria-describedby="live-feedback"
          />
          <b-form-invalid-feedback product="live-feedback">
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <validation-provider
        name="Açıklama"
        :rules="{ required: false }"
        v-slot="validationContext"
      >
        <b-form-group class="editor" label="Açıklama" label-for="desc">
          <b-form-textarea
            id="desc"
            rows="5"
            v-model="description"
            :state="getValidationState(validationContext)"
            aria-describedby="live-feedback"
          ></b-form-textarea>
          <b-form-invalid-feedback desc="live-feedback">{{
            validationContext.errors[0]
          }}</b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>
      </div>

      <div v-else>
      <validation-provider
        name="Dosya"
        :rules="{ required: false }"
        v-slot="validationContext"
      >
        <b-form-group class="inputGrp" label="" label-for="file">
          <b-form-file
            multiple
            v-model="files"
            file_id="file"
            placeholder="Dosyayı yükle veya sürükle"
            drop-placeholder="Dosyayı yükle veya sürükle"
            :state="getValidationState(validationContext)"
            aria-describedby="live-feedback"
          ></b-form-file>
          <b-form-invalid-feedback
            subcejtTitle_id="live-feedback"
            class="mt-2 ml-2"
            >{{ validationContext.errors[0] }}</b-form-invalid-feedback
          >
        </b-form-group>
      </validation-provider>

      </div>
    </b-form>
  </validation-observer>
</template>

<script>
import Multiselect from "vue-multiselect";
// import i18n from '@/plugins/i18n'

export default {
  name: "AddFaultSupport",
  components: {
    Multiselect
  },
  props: {
    part: {
      type: String,
      default: "info"
    }
  },
  data() {
    return {
      description: null,
      serialNumber: null,
      problem: null,
      files: null,
      selectedPieces: [],
    }
  },
  computed: {
    pieces() {
      return this.$store.getters.pieces
    }
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    addTag (tag) {
      this.selectedPieces.push(tag)
    }  
  },
  async created() {
    await this.$store.dispatch('fetchPieces')
  }
};
</script>

<style lang="css" scoped >
</style>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/components/AddFaultSupportForm.vue